import WeddingDashboard from '../../components/UserDashboard/WeddingDashboard/WeddingDashboard.jsx'

export const KazooDashboardPage = () => {
	return <WeddingDashboard />
}
